'use client';
import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';
import styles from './CommonHeader.module.scss.mjs';

const cx = classNames.bind(styles);
const CommonHeader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    align,
    bgColor,
    children,
    leftComponent,
    rightComponent,
    innerClassName
  } = _ref;
  return /*#__PURE__*/React.createElement("header", {
    className: cx('article', align, {
      [`bg-${bgColor}`]: bgColor
    }),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('inner', innerClassName)
  }, children, leftComponent && /*#__PURE__*/React.createElement("div", {
    className: cx('aside-left')
  }, leftComponent), rightComponent && /*#__PURE__*/React.createElement("div", {
    className: cx('aside-right')
  }, rightComponent)));
});
CommonHeader.displayName = 'CommonHeader';

export { CommonHeader as default };
